'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
const textPath = 'ecosystemMarketplaceCore.reviews.actions';

const ReportButton = ({
  className,
  isCustomer,
  onClick
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isCustomer,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.loginRequired`
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      className: className,
      disabled: !isCustomer,
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${textPath}.report`
      })
    })
  });
};

ReportButton.propTypes = {
  className: PropTypes.string,
  isCustomer: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};
export default ReportButton;